import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Trash icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Trash } from '@sravni/design-system-icons'
 *
 * <Trash />
 * ```
 */
var Trash = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Trash", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M2.5 5.75A.75.75 0 0 1 3.25 5H5.5v1.5H3.25a.75.75 0 0 1-.75-.75ZM14.5 5h2.25a.75.75 0 0 1 0 1.5H14.5V5Z", fill: "currentColor" }),
    React.createElement("path", { d: "M4.374 6.029a.25.25 0 0 1 .248-.279h10.756c.15 0 .266.13.248.279l-1.269 11a.25.25 0 0 1-.248.221H5.89a.25.25 0 0 1-.248-.221l-1.27-11ZM12 5.75h.75V4.5A1.75 1.75 0 0 0 11 2.75H9A1.75 1.75 0 0 0 7.25 4.5v1.25H12Z", stroke: "currentColor", strokeWidth: "1.5" }),
    React.createElement("path", { d: "M9.25 8.75a.75.75 0 1 0-1.5 0v5.5a.75.75 0 0 0 1.5 0v-5.5ZM12.25 8.75a.75.75 0 0 0-1.5 0v5.5a.75.75 0 0 0 1.5 0v-5.5Z", fill: "currentColor" }))); });

export { Trash };
//# sourceMappingURL=Trash.js.map
